import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PrimaryButtonComponent from '../Buttons/PrimaryButton/PrimaryButton.component';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.red};
  background-color: ${({ theme }) => theme.colors.redLight};
  border-radius: ${({ theme }) => theme.borderRadius};
  color: ${({ theme }) => theme.colors.redDark};
  margin: 20px 0;
`;

const ErrorIcon = styled.div`
  font-size: 50px;
  margin-bottom: 10px;
`;
const ErrorMessage = ({ message }) => {
  const onRetry = () => {
    window.location.reload();
  };
  return (
    <ErrorContainer>
      <ErrorIcon>⚠️</ErrorIcon>
      <ErrorMessage>
        {message || 'An error occurred. Please try again.'}
      </ErrorMessage>
      {onRetry && (
        <PrimaryButtonComponent onClick={onRetry}>Retry</PrimaryButtonComponent>
      )}
    </ErrorContainer>
  );
};
ErrorMessage.propTypes = {
  message: PropTypes.string,
};

export default ErrorMessage;
